import * as z from 'zod';

import { fileQuerySchema } from '@/_schemas/file';
import { numericStringFormSchema } from '@/_schemas/generic';
import { statusFormSchema } from '@/_schemas/status-input';

import { commissionPeriodsFormSchema } from './commission-periods-schema';
import { teamMemberQuerySchema } from './team-members-query-schema';

import { genderFormSchema } from '../../../../_containers/inputs/gender';
import { interestsSchema } from '../../../../_containers/inputs/interests';
import { shirtSizePreferenceFormSchema, techPreferenceFormSchema } from '../components';

export const teamMemberFormSchema = teamMemberQuerySchema
  .omit({
    status: true,
    biography: true,
    interests: true,
    birthdate: true,
    spouse_name: true,
    children_names: true,
    pet_names: true,
    parent_id: true,
    preferred_relationship_id: true,
    gallery: true,
  })
  .extend({
    first_name: z.string().min(3),
    last_name: z.string().min(3),
    status: statusFormSchema,
    biography: z.string(),
    interests: interestsSchema(),
    birthdate: z.string().optional(),
    spouse_name: z.string(),
    children_names: z.string(),
    pet_names: z.string(),

    gender: genderFormSchema.nullable(),
    tech_preference: techPreferenceFormSchema.nullable(),
    t_shirt_size: shirtSizePreferenceFormSchema.nullable(),

    internal_extension: z.string(),
    job_title: z.string(),
    personal_email: z.string(),
    work_email: z.string(),
    hr_identifier: z.string(),
    hired_on: z.string(),
    termination: z.string(),
    tax_type: z.string(),

    gallery: z.array(fileQuerySchema),

    gusto: z.string(),
    harvest: numericStringFormSchema(),
    zoom: numericStringFormSchema(),
    freshdesk: numericStringFormSchema(),

    commission_periods: z.array(commissionPeriodsFormSchema).nullish(),

    /**
     * Financial Override PIN (revenue lockdown override PIN).
     * Optional and only shown to users with Financial Override permission.
     */
    lockdown_override_pin: z
      .string()
      .optional()
      .refine(
        (v) => {
          if (!v) return true;
          return v.length === 4;
        },
        {
          message: 'PIN must be 4 digits',
        }
      ),
  });

export type TeamMemberFormSchema = z.infer<typeof teamMemberFormSchema>;
